import { io } from "socket.io-client";

const BASE_URL = "https://api.growthstationco.com";

let socket = null;
let pendingActions = [];
// ✅ FIX: كان فيه متغيّر واحد بس "lastJoinedRoomId" بيتكتب فوقه في
// كل مرة joinRoom() بتتنادى. التطبيق فعليًا بينضم لأكتر من room
// في نفس الوقت (كل الجروبات اللي اليوزر عضو فيها)، فكان عند أي
// reconnect (قطع نت بسيط/تطبيق راح background) بيتعمل rejoin
// لآخر room بس، والباقي بيفقد عضويته في الـ socket room من غير
// ما حد يحس، فمش بتوصل رسائل لايف فيهم لحد ما يعمل refresh.
// دلوقتي بنحتفظ بـ Set فيه كل الـ rooms المنضم لها، وعند أي
// reconnect بنعمل rejoin للكل مش لواحد بس.
const joinedRoomIds = new Set();
let disconnectCount = 0;
let currentRoomId = null;

const messageSubscribers = new Set();
const notificationSubscribers = new Set();

// ─── يقرأ التوكن بنفس المفتاح اللي بيتحفظ بيه في AuthContext ───
function readStoredToken() {
  return (
    localStorage.getItem("Token") ||
    localStorage.getItem("token") ||
    null
  );
}

// ─── groupDiscovery subscribers — بيتبعتلهم أي room جديد اكتُشف ─
const groupDiscoverySubscribers = new Set();

export const subscribeToGroupDiscovery = (callback) => {
  if (typeof callback !== "function") return () => {};
  groupDiscoverySubscribers.add(callback);
  return () => groupDiscoverySubscribers.delete(callback);
};

export const connectSocket = (token) => {
  const authToken = token || readStoredToken();
  if (!authToken) {
    console.warn("connectSocket: No Token found");
    return null;
  }

  if (socket?.connected) return socket;

  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
  }

  socket = io(BASE_URL, {
    auth: { token: authToken },
    transports: ["polling", "websocket"],
    upgrade: true,
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    timeout: 10000,
  });

  socket.on("connect", async () => {
    console.log("✅ CONNECTED:", socket.id);
    disconnectCount = 0;

    // ✅ FIX: rejoin لكل الـ rooms المعروفة (مش room واحد بس)
    if (joinedRoomIds.size > 0) {
      joinedRoomIds.forEach((roomId) => {
        socket.emit("joinRoom", roomId);
      });
      console.log("🔁 Re-joined rooms after (re)connect:", [...joinedRoomIds]);
    }

    const actions = [...pendingActions];
    pendingActions = [];
    actions.forEach((fn) => fn(socket));
  });

  socket.onAny((event, data) => {
    console.log("SOCKET EVENT:", event, data);
  });

  socket.on("disconnect", (reason) => {
    console.log("🔌 DISCONNECTED:", reason);

    if (reason === "io server disconnect") {
      disconnectCount += 1;
      console.warn(
        `⚠️ السيرفر قطع الاتصال بنفسه (${disconnectCount} مرة/مرات متتالية).`
      );

      if (disconnectCount <= 5) {
        setTimeout(() => {
          if (!socket?.connected) socket?.connect();
        }, 1000);
      } else {
        console.error(
          "🛑 توقفنا عن إعادة المحاولة بعد 5 قطعات متتالية من السيرفر."
        );
      }
    }
  });

  socket.on("connect_error", (err) => {
    console.error("❌ CONNECT ERROR:", err.message);
  });

  socket.on("receiveMessage", (message) => {
    const incomingRoomId = message?.roomId;

    // ✅ FIX: شيلنا استدعاء groupDiscoverySubscribers من هنا خالص.
    // ده كان هو سبب المشكلة: أي رسالة توصل لـ private chat عادي
    // (مش جروب) كان بيتعامل معاها على إنها "جروب مكتشف جديد"،
    // فكانت تتحط تلقائيًا في تاب Groups باسم "New Group" — وده
    // غلط، لأن مفيش معيار هنا بيفرّق بين private message وgroup
    // message. اكتشاف الجروبات الجديدة دلوقتي بيحصل حصريًا عن
    // طريق حدث "newGroup" الصريح اللي السيرفر/الكلاينت التاني
    // بيبعته فعليًا وقت إنشاء جروب (شوف socket.on("newGroup") تحت).

    // إبلاغ notification subscribers (للـ toast وعداد الرسائل)
    notificationSubscribers.forEach((cb) => {
      try {
        cb(message);
      } catch (err) {
        console.error("notification subscriber error:", err);
      }
    });

    // إبلاغ message subscribers (الرسائل الظاهرة في الشات المفتوح)
    if (String(incomingRoomId) === String(currentRoomId)) {
      messageSubscribers.forEach((cb) => {
        try {
          cb(message);
        } catch (err) {
          console.error("message subscriber error:", err);
        }
      });
    }
  });

  // ✅ المصدر الوحيد لاكتشاف جروب جديد: حدث newGroup الصريح،
  // اللي بيتبعت فقط وقت إنشاء جروب فعلي (مش عند أي رسالة عادية).
  socket.on("newGroup", (groupData) => {
    console.log("📢 newGroup event received:", groupData);
    // أي جروب جديد بيوصل عن طريق الحدث ده، نضيفه لقايمة الـ rooms
    // المنضم لها عشان لو السوكيت قطع وعاد يرجع ينضم له تاني.
    if (groupData?._id) joinedRoomIds.add(groupData._id);
    groupDiscoverySubscribers.forEach((cb) => {
      try {
        cb({ _isNewGroupEvent: true, ...groupData });
      } catch (err) {
        console.error("groupDiscovery (newGroup) subscriber error:", err);
      }
    });
  });

  return socket;
};

export const joinRoom = (roomId, token) => {
  if (!roomId) return;
  // ✅ FIX: بنضيف الـ room للـ Set بدل ما نكتب فوق متغيّر واحد —
  // كده أي room اتعمله join يفضل متذكور ويترجع ينضم له تاني عند
  // أي reconnect، مش بس آخر واحد.
  joinedRoomIds.add(roomId);

  if (socket?.connected) {
    socket.emit("joinRoom", roomId);
    console.log("🚪 Joined room:", roomId);
    return;
  }

  const authToken = token || readStoredToken();
  if (!socket) {
    connectSocket(authToken);
  } else if (!socket.connected) {
    socket.connect();
  }
};

export const emitWhenConnected = (token, event, data) => {
  const authToken = token || readStoredToken();

  if (socket?.connected) {
    socket.emit(event, data);
    console.log(`📤 Emitted ${event}:`, data);
    return;
  }

  console.log(`⏳ Queued ${event} until connected`);
  pendingActions.push((connectedSocket) => {
    connectedSocket.emit(event, data);
    console.log(`📤 Emitted (queued) ${event}:`, data);
  });

  if (!socket) {
    connectSocket(authToken);
  } else if (!socket.connected) {
    socket.connect();
  }
};

// ✅ FIX: كانت بتمسح الـ room المتذكور بالكامل (lastJoinedRoomId =
// null)، وده كان بيخلي أي rooms اتعملها join قبل كده (الجروبات
// المحمّلة عند فتح الصفحة مثلاً) تتنسى تمامًا أول ما اليوزر يفتح
// أي محادثة جديدة. دلوقتي الدالة دي بس بتصفّر تتبّع "الروم النشط
// حاليًا" (currentRoomId عن طريق setCurrentRoomId) من غير ما تأثر
// على قايمة كل الـ rooms المنضم لها فعليًا.
export const clearLastJoinedRoom = () => {
  // مقصودة فاضية الآن: الانضمام الفعلي للـ rooms بيتسجل في
  // joinedRoomIds ومش المفروض يتمسح غير لو حصل disconnectSocket()
  // الكامل (خروج تسجيل دخول مثلاً).
};

export const getSocket = () => socket;

export const disconnectSocket = () => {
  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
  }
  pendingActions = [];
  joinedRoomIds.clear();
  disconnectCount = 0;
  currentRoomId = null;
  messageSubscribers.clear();
  notificationSubscribers.clear();
  groupDiscoverySubscribers.clear();
};

export const setCurrentRoomId = (roomId) => {
  currentRoomId = roomId;
};

export const getCurrentRoomId = () => currentRoomId;

export const subscribeToMessages = (callback) => {
  if (typeof callback !== "function") return () => {};
  messageSubscribers.add(callback);
  return () => messageSubscribers.delete(callback);
};

export const subscribeToNotifications = (callback) => {
  if (typeof callback !== "function") return () => {};
  notificationSubscribers.add(callback);
  return () => notificationSubscribers.delete(callback);
};

export const setMessageCallbacks = (onMessage, onNotification) => {
  console.warn(
    "setMessageCallbacks is deprecated — use subscribeToMessages/subscribeToNotifications instead"
  );
  messageSubscribers.clear();
  notificationSubscribers.clear();
  if (onMessage) messageSubscribers.add(onMessage);
  if (onNotification) notificationSubscribers.add(onNotification);
};